import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner',
  template: `<mat-spinner [diameter]="60"></mat-spinner>`,
  styles: []
})
export class SpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
